import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import Footer from "components/footer/FooterAuth";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import { NavLink } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";

function AuthIllustration(props) {
  const { children, illustrationBackground } = props;
  return (
    <Flex position='relative' h='max-content'>
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w='100%'
        maxW={{ md: "66%", lg: "1313px" }}
        mx='auto'
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent='start'
        direction='column'>
        <NavLink
          to='/admin'
          style={() => ({
            width: "fit-content",
            marginTop: "40px",
          })}>
          <Flex
            align='center'
            ps={{ base: "25px", lg: "0px" }}
            pt={{ lg: "0px", xl: "0px" }}
            w='fit-content'>
            <Icon
              as={FaChevronLeft}
              me='12px'
              h='13px'
              w='8px'
              color='secondaryGray.600'
            />
            <Text ms='0px' fontSize='sm' color='secondaryGray.600'>
              Dashboard
            </Text>
          </Flex>
        </NavLink>
        {children}
       <Box
  display={{ base: "none", md: "flex" }}
  h="100%"
  minH="100vh"
  w={{ lg: "50vw", "2xl": "44vw" }}
  position="absolute"
  right="0"
  alignItems="center"
  justifyContent="center"
  // bgGradient="linear(to-br, #181e41 0%, #274bdb 60%, #3ec6e0 100%)"
bgGradient="linear(to-br, #0e1729 0%, #263f68 60%, #4e6fa9 100%)"
  borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}
  flexDirection="column"
  p={12}
  textAlign="center"
  boxShadow="xl"
>
  <img
    src="./Logo-Prowess-Icon_new.png" 
    alt="Employee Portal Illustration"
    style={{
      maxWidth: "250px",
      marginBottom: "2.5rem",
      opacity: 0.96,
      objectFit: "contain",
      userSelect: "none",
      pointerEvents: "none"
    }}
  />

  <Text
    fontSize={{ base: "2xl", md: "3xl" }}
    fontWeight="bold"
    color="white"
    mb={3}
    mx="auto"
    maxW="340px"
    lineHeight="1.2"
    letterSpacing="tight"
    textShadow="0 4px 24px #181e41AA"
  >
    Welcome to Employee Portal
  </Text>

  <Text
    fontSize="lg"
    color="whiteAlpha.900"
    maxW="400px"
    mx="auto"
    fontWeight="medium"
    mt={2}
    opacity={0.92}
  >
    Seamlessly manage your work, attendance, and leave applications with a beautiful and secure interface.
  </Text>
</Box>

        <Footer />
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
